import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AllProductsComponent } from './components/all-products/all-products.component';
import { ArchitectureServiceComponent } from './components/architecture-service/architecture-service.component';
import { CloudEngineeringComponent } from './components/cloud-engineering/cloud-engineering.component';
import { DataComponent } from './components/data/data.component';
import { OneViewComponent } from './components/one-view/one-view.component';
import { PlatformsComponent } from './components/platforms/platforms.component';
import { LandingPageComponent } from './landing-page.component';


const routes: Routes = [
    {
        path: '',
        component: LandingPageComponent,
        children: [
            { path: 'landing-page', redirectTo: 'all-products', pathMatch: 'full' },
            { path: 'all-products', component: AllProductsComponent },
            { path: 'architecture-service', component: ArchitectureServiceComponent },
            { path: 'platforms', component: PlatformsComponent },
            { path: 'cloud-engineering', component: CloudEngineeringComponent },
            { path: 'data', component: DataComponent },
            { path: 'one-view', component: OneViewComponent }
        ]
    }
];

@NgModule({
    imports: [ RouterModule.forChild(routes) ],
    exports: [ RouterModule ],
})
export class LandingPageRoutingModule { }
